import { IPurchaseIndentUpload } from "common/interface/IPurchaseIndent";

const STORAGE_KEY = "processingPurchaseIndent";

export const persistProcessingPurchaseIndent = (data: IPurchaseIndentUpload) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const getPersistedProcessingPurchaseIndent = (): IPurchaseIndentUpload => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : {};
};

export const removePersistedProcessingPurchaseIndent = () => {
  localStorage.removeItem(STORAGE_KEY);
};
